<template>
  <div class="login-links" v-if="isRegister || isFindPwd || isRemember">
    <span class="remember-me" v-if="isRemember" @click="rememberMe">
      <i class="remember-icon" :class="{ 'checked': rememberChecked }"></i>
      <b class="remember-txt">记住我</b>
    </span>
    <span class="change-login" v-if="loginType === ACCOUNT_TYPE"
      @click="changeLoginType(PHONE_TYPE)">短信登录</span>
    <span class="change-login" v-if="loginType === PHONE_TYPE"
      @click="changeLoginType(ACCOUNT_TYPE)">账号密码登录</span>
    <span class="find-pwd" v-if="isFindPwd" @click="findPwd">忘记密码</span>
  </div>
</template>

<script>
import { ENV_API_HOST, ACCOUNT_TYPE, PHONE_TYPE } from '../libs/constants';

export default {
  name: 'login-links',
  props: {
    env: { type: String, default: '' },
    loginType: { type: String, default: ACCOUNT_TYPE },
    isRegister: { type: Boolean, default: true },
    isFindPwd: { type: Boolean, default: true },
    isRemember: { type: Boolean, default: false },
    isRememberChecked: { type: Boolean, default: false },
  },
  data() {
    return {
      PHONE_TYPE,
      ACCOUNT_TYPE,
      rememberChecked: this.isRememberChecked || false,
    };
  },
  methods: {
    // 忘记密码
    findPwd() {
      const url = `${ENV_API_HOST[this.env].graph}/find_pwd?redirect_uri=${window.location.href}`;
      window.open(url);
    },
    // 切换登录
    changeLoginType(type) {
      this.$emit('changeLoginType', type);
    },
    // 记住我
    rememberMe() {
      this.rememberChecked = !this.rememberChecked;
      this.$emit('rememberMe', this.rememberChecked);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.login-links {
  position: relative;
  font-size: 14px;
  min-height: 19px;
  padding-bottom: 0;
  color: #333;
  .remember-me {
    -webkit-user-select: none;
    user-select: none;
    margin-right: 15px;
    cursor: pointer;
    position: relative;
    .remember-icon {
      background: url('../imgs/checkbox.png') center no-repeat;
      background-size: 16px auto;
      width: 16px;
      height: 16px;
      position: absolute;
      left: 0;
      top: 1px;
      &.checked {
        color: $mainColor;
        background-image: url('../imgs/checkbox-on.png');
      }
    }
    .remember-txt {
      font-weight: normal;
      margin: 0 3px 0 24px;
    }
    &:after {
      position: relative;
      top: 3px;
      right: -5px;
      content: '';
      display: inline-block;
      visibility: visible;
      width: 1px;
      height: 14px;
      background-color: #DDD;
      position: relative;
    }
  }
  .find-pwd {
    position: absolute;
    right: 0;
    cursor: pointer;
  }
  .change-login {
    cursor: pointer;
  }
  .to-register {
    position: static;
    right: 0;
    color: $mainColor;
    cursor: pointer;
  }
}
</style>
